/**
 * @module orderStatus
 * @description A list of orderStatus
 */
export const orderStatus = [
	'draft',
	'onhold',
	'accepted',
	'cancelled',
] as const;
export type OrderStatus = (typeof orderStatus)[number];
